'use client';

import { ErrorPage as ErrorComponent } from '~/components/ErrorPage/ErrorPage';

export default function ErrorPage({ statusCode }: { statusCode: number }) {
  return <ErrorComponent statusCode={statusCode} />;
}
